<sn-drawer toastContainer>
  <sn-icon-button icon="close" snDrawerClose snDrawerNavButton></sn-icon-button>
  <sn-drawer-content id="sentry-results-drawer">
    <fs-sentry-results-component [inputValue]="data"></fs-sentry-results-component>
  </sn-drawer-content>
</sn-drawer>
